export default __webpack_public_path__ + "static/media/kitchen1-1440w.1c0d9108.png";